/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Automatic_Translation_TitleInputs */

const en_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Translation`)
};

const fr_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction Automatique`)
};

const de_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Übersetzung`)
};

const it_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione automatica`)
};

const ru_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический перевод`)
};

const es_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción automática`)
};

const zh_cn2_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动翻译`)
};

const ja_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動翻訳`)
};

const hi_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित अनुवाद`)
};

const pt_pt2_toolbar_secondary_automatic_translation_title = /** @type {(inputs: Toolbar_Secondary_Automatic_Translation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução automática`)
};

/**
* | output |
* | --- |
* | "Automatic Translation" |
*
* @param {Toolbar_Secondary_Automatic_Translation_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_automatic_translation_title = /** @type {((inputs?: Toolbar_Secondary_Automatic_Translation_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Automatic_Translation_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "de") return de_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "it") return it_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "es") return es_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_automatic_translation_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_automatic_translation_title(inputs)
	return en_toolbar_secondary_automatic_translation_title(inputs)
});